import React from 'react';

import { cn } from 'lib/utils';
import { useServerNow } from 'shared/queries/serverTime';

function formatMmSs(ms: number) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  return `${mm}:${ss}`;
}

const FLASH_UNDER_MS = 30_000;

export default function EventCountdown(props: {
  targetMs: number;
  nowMs?: number;
  onComplete?: () => void;
  className?: string;
}) {
  const { targetMs, onComplete, nowMs, className } = props;
  const serverNow = useServerNow();
  const effectiveNow = nowMs ?? serverNow;

  const completedRef = React.useRef(false);
  const remainingMs = targetMs - effectiveNow;
  const isUrgent = remainingMs > 0 && remainingMs < FLASH_UNDER_MS;

  React.useEffect(() => {
    // When the target changes (e.g. we advanced to the next event),
    // allow completion to fire again for the new target.
    completedRef.current = false;
  }, [targetMs]);

  React.useEffect(() => {
    if (completedRef.current) return;
    if (remainingMs <= 0) {
      completedRef.current = true;
      onComplete?.();
    }
  }, [onComplete, remainingMs]);

  return (
    <span className={cn(className, isUrgent && 'animate-pulse')}>
      {formatMmSs(remainingMs)}
    </span>
  );
}

